import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { firebaseConfig, platformConfig } from '../config/config'

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app)

// Connect to emulators in development (DISABLED - using real Firebase)
// Uncomment and run `firebase emulators:start` to use emulators
/*
if (platformConfig.environment === 'development' && typeof window !== 'undefined') {
  const shouldUseEmulator = window.location.hostname === 'localhost'
  
  if (shouldUseEmulator) {
    try {
      connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
      connectFirestoreEmulator(db, 'localhost', 8080)
      connectStorageEmulator(storage, 'localhost', 9199)
      connectFunctionsEmulator(functions, 'localhost', 5001)
      console.log('🔥 Connected to Firebase Emulators')
    } catch (error) {
      console.log('Emulators already connected or not available')
    }
  }
}
*/

console.log('🔥 Firebase initialized - using production services')

export default app
